import {useCallback, useState} from "react";
import {useLocation} from "react-router";

import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {hotlineTelNumber} from "../../types/HotlineTelNumber";
import {useLazyGetClipPhoneByPropertyIdQuery} from "../api/application_lead_data_api";

export const useApplicationPhoneClipNumber = (fallbackPhoneNumber?: string | null, useHotlineNumber?: boolean) => {
    const [phoneNumber, setPhoneNumber] = useState<string | null>();
    const [isClipPhoneBlocked, setClipPhoneBlocked] = useState(false);
    const location = useLocation();

    const [triggerGetClipPhone, {isFetching, isUninitialized}] = useLazyGetClipPhoneByPropertyIdQuery();

    const fetchClipPhoneNumber = useCallback(
        async (propertyId?: number) => {
            if (useHotlineNumber) {
                setPhoneNumber(hotlineTelNumber);
                return;
            }
            if (propertyId) {
                try {
                    const res = await triggerGetClipPhone({propertyId}).unwrap();
                    setPhoneNumber(res?.clip_number || fallbackPhoneNumber);
                } catch (error: unknown) {
                    const status = error && typeof error === "object" && "status" in error ? (error as {status: number}).status : undefined;
                    if (status === 404) {
                        notifyBugsnag({name: "Phone clip display blocked", message: "Phone clip display blocked"}, "Phone clip on an archived offer", {
                            error,
                            propertyId,
                            location
                        });
                        setClipPhoneBlocked(true);
                    }
                    setPhoneNumber(fallbackPhoneNumber);
                }
            } else {
                setPhoneNumber(fallbackPhoneNumber);
            }
        },
        [fallbackPhoneNumber]
    );

    return {
        phoneNumber,
        isClipPhoneBlocked,
        fetchClipPhoneNumber,
        isFetching,
        isUninitialized
    };
};
import {useCallback, useState} from "react";
import {useLocation} from "react-router";

import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {hotlineTelNumber} from "../../types/HotlineTelNumber";
import {useLazyGetClipPhoneByPropertyIdQuery} from "../api/application_lead_data_api";

export const useApplicationPhoneClipNumber = (fallbackPhoneNumber?: string | null, useHotlineNumber?: boolean) => {
    const [phoneNumber, setPhoneNumber] = useState<string | null>();
    const [isClipPhoneBlocked, setClipPhoneBlocked] = useState(false);
    const location = useLocation();

    const [triggerGetClipPhone, {isFetching, isUninitialized}] = useLazyGetClipPhoneByPropertyIdQuery();

    const fetchClipPhoneNumber = useCallback(
        async (propertyId?: number) => {
            if (useHotlineNumber) {
                setPhoneNumber(hotlineTelNumber);
                return;
            }
            if (propertyId) {
                try {
                    const res = await triggerGetClipPhone({propertyId}).unwrap();
                    setPhoneNumber(res?.clip_number || fallbackPhoneNumber);
                } catch (error: unknown) {
                    const status = error && typeof error === "object" && "status" in error ? (error as {status: number}).status : undefined;
                    if (status === 404) {
                        notifyBugsnag({name: "Phone clip display blocked", message: "Phone clip display blocked"}, "Phone clip on an archived offer", {
                            error,
                            propertyId,
                            location
                        });
                        setClipPhoneBlocked(true);
                    }
                    setPhoneNumber(fallbackPhoneNumber);
                }
            } else {
                setPhoneNumber(fallbackPhoneNumber);
            }
        },
        [fallbackPhoneNumber]
    );

    return {
        phoneNumber,
        isClipPhoneBlocked,
        fetchClipPhoneNumber,
        isFetching,
        isUninitialized
    };
};
